import React from 'react'
import { useSettings } from '../contexts/SettingsContext'

const defaultLogoUrl = '/logosinitechnologie.jpeg'

interface SiniBrandProps {
  compact?: boolean
  light?: boolean
  className?: string
}

const SiniBrand: React.FC<SiniBrandProps> = ({ compact = false, light = false, className = '' }) => {
  const { get: getSetting } = useSettings()
  const configuredLogo = String(getSetting('branding.logo_url', '') || '')
  const logoUrl = configuredLogo || defaultLogoUrl
  if (compact) {
    return (
      <div
        className={`relative h-10 w-28 overflow-hidden rounded-md bg-white ${className}`}
        aria-label="SINI Technology"
      >
        <img
          src={logoUrl}
          alt="SINI Technology"
          className={`absolute left-1/2 top-1/2 w-[145%] max-w-none -translate-x-1/2 -translate-y-1/2 ${light ? 'brightness-110' : ''}`}
        />
      </div>
    )
  }

  return (
    <div
      className={`relative h-24 w-64 overflow-hidden rounded-xl bg-white ${className}`}
      aria-label="SINI Technology"
    >
      <img
        src={logoUrl}
        alt="SINI Technology"
        className={`absolute left-1/2 top-1/2 w-[132%] max-w-none -translate-x-1/2 -translate-y-1/2 ${light ? 'brightness-110' : ''}`}
      />
    </div>
  )
}

export default SiniBrand
